import { STATUS_TYPES } from './status-types.enum';

export class Status {
	type: STATUS_TYPES;
	toolTip?: string;

	constructor(type: STATUS_TYPES, tooltip?: string) {
		this.type = type;
		this.toolTip = tooltip;
	}
}
